import {OnlyBinaryHeaderArg} from "@psdk/frame-father";

export class CStatus extends OnlyBinaryHeaderArg<CStatus> {

  constructor() {
    super();
  }

  header(): Uint8Array {
    return new Uint8Array([0x10, 0x04, 0x05]);
  }

  newline(): boolean {
    return false;
  }

}



